<template>
  <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="600px" :destroy-on-close="true" append-to-body :before-close="cancel">
    <div>
      <el-form label-width="100px" ref="form" :model="form" :rules="rules">
        <el-form-item label="物料类型" prop="materialType">
          <el-select style="width: 400px;" v-model="form.materialType" placeholder="请选择物料类型" filterable>
            <el-option v-for="item in TypeOptions" :key="item.label" :label="item.name" :value="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类一" prop="classOne" v-if="form.materialType==='SINGLE_PAGER'">
          <el-input style="width: 400px;" v-model="form.classOne" auto-complete="off" placeholder="请输入分类一"></el-input>
        </el-form-item>
        <el-form-item label="分类二" prop="classTwo" v-if="form.materialType === 'SINGLE_PAGER'">
          <el-input style="width: 400px;" v-model="form.classTwo" auto-complete="off" placeholder="请输入分类二"></el-input>
        </el-form-item>
        <el-form-item label="物料名称" prop="materialName">
          <el-input style="width: 400px;" v-model="form.materialName" auto-complete="off" placeholder="请输入物料名称"></el-input>
        </el-form-item>
        <el-form-item label="物料位置" prop="materialPlace">
          <el-input style="width: 400px;" v-model="form.materialPlace" auto-complete="off" placeholder="请输入物料位置"></el-input>
        </el-form-item>
        <el-form-item label="最大申领数量" prop="limitQuantity">
          <el-input style="width: 400px;" v-model="form.limitQuantity" auto-complete="off" placeholder="请输入最大申领数量"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input style="width: 400px;" v-model="form.remark" type="textarea" :autosize="{ minRows: 3}" maxlength="300" show-word-limit placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item label="附件" prop="file">
          <el-upload :auto-upload="false" action="" :file-list="fileList" :on-remove="handleRemove"
                     :limit="1" :on-change="handleChange" :on-exceed="handleExceed">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" class="title" @click="cancel">取消</el-button>
      <el-button size="small" type="primary" class="title" @click="handle">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>

import {addLexicon, attachmentAnnex, editLexicon} from "@/api/dilivery/material/lexicon";
import {getDataInLocalStorage} from "@/utils/localStorage";

export default {
  name: "AddEditLexicon",
  props:['showDialog','selectType','selectDetail'],
  data(){
    return{
      title:'',
      fileList: [],
      form:{
        classOne:'',
        classTwo:'',
        remark:'',
        materialType:'',
        materialName:'',
        materialPlace:'',
        limitQuantity:'',
        file:null
      },
      rules: {
        materialType: [
          { required: true, message: '请选择物料类型', trigger: 'change' }
        ],
        materialName: [
          { required: true, message: '请输入物料名称', trigger: 'change' }
        ],
        classOne: [
          { required: true, message: '请输入分类一', trigger: 'change' }
        ],
        classTwo: [
          { required: true, message: '请输入分类二', trigger: 'change' }
        ],
        limitQuantity: [
          {
            pattern: /^[1-9]\d*$/,
            message: '请输入大于0的整数',
            trigger: 'change'
          }
        ]
      }
    }
  },
  computed:{
    TypeOptions() {
      if (['ADMIN','MANAGER','TECH'].includes(getDataInLocalStorage('role'))) {
        return [
          {label:'PROTECT_REAGENT',name:'保护剂'},
          {label:'SINGLE_PAGER',name:'宣传品'},
          {label:'GIFT',name:'礼品'},
          {label:'NAME_CARD',name:'名片'},
          {label:'DRY_ICE',name:'干冰'},
          {label:'OTHER',name:'其他'},
        ]
      } else {
        return []
      }
    },
    role(){
      return getDataInLocalStorage('role')
    }
  },
  watch:{
    selectType:{
      handler(newVal){
        if (newVal){
          if(newVal==='edit'){
            this.title='编辑词库信息'
          }else{
            this.title='添加词库信息'
          }
        }
      },
      immediate:true
    },
    selectDetail:{
      handler(newVal){
        if(newVal&&Object.keys(newVal)){
          this.form.id = newVal.id
          if(newVal['annexExistFlag'] && newVal.id){
            this.addFileManually(newVal.id)
          }
          this.form.materialType = newVal.materialType
          this.form.materialName = newVal.materialName
          this.form.materialPlace = newVal.materialPlace
          this.form.limitQuantity = newVal.limitQuantity
          this.form.classOne = newVal.classOne
          this.form.classTwo = newVal.classTwo
          this.form.remark = newVal.remark
        }
      },
      immediate:true
    },
  },
  methods:{
    async addFileManually(id){
      try{
        const response = await attachmentAnnex(id);
        const urlCreator = window.URL || window.webkitURL;
        const url = urlCreator.createObjectURL(response.file)
        const file = new File([response.file],decodeURI(response.fileName), {type: response.file.type});
        // 创建一个文件对象的包装对象
        const fileWrapper = {
          name: file.name,
          status: 'ready',
          raw: file,  // 实际的文件对象
          url:url
        };
        this.form.file = fileWrapper;
        this.fileList.push(fileWrapper);
      } catch (error) { console.log(error); }
    },
    handleExceed(files) {
      this.$messageUi.error('只能上传一个文件，请先移除已有文件再上传'); // 超出数量时提醒
    },
    handleChange(file, fileList) {
      this.form.file = file;
      this.fileList = fileList
    },
    handleRemove(file) {
      // 可选，处理文件移除逻辑
      this.form.file = null; // 更新已选择的文件
      this.fileList = []
    },
    cancel(){
      this.$emit('submit','cancel')
    },
    handle(){
      this.$refs.form.validate(valid=>{
        if(valid){
          const formData = new FormData();
          for (const key in this.form) {
            if (this.form.hasOwnProperty(key)) {
              if (key === 'limitQuantity') {
                formData.append(key, this.form[key] ?? '');
              }else if (key !== 'file') {
                formData.append(key, this.form[key]);
              } else {
                if(this.form.file !== null){
                  formData.append('file', this.form.file.raw);
                }
              }
            }
          }
          if(this.selectType === 'add'){
            addLexicon(formData).then(res => {
              if (res.code === 200) {
                this.$emit('submit','confirm')
                this.$messageUi.success('提交成功')
              }
            }).catch(err => {
            })
          }else{
            editLexicon(formData).then(res => {
              if (res.code === 200) {
                this.$emit('submit','confirm')
                this.$messageUi.success('修改成功')
              }
            }).catch(err => {
            })
          }
        }else {
          this.$nextTick(() => {
            let err = document.getElementsByClassName('is-error')
            if (err.length) {
              err[0].scrollIntoView({
                block: 'center',
                behavior: 'smooth',
              })
            }
          })
          this.$messageUi.error('填写参数不规范，请检查')
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
